import React, { useState, useEffect, useContext, useRef } from 'react';


import AddModal from '../../../components/modals/addModal';
import EditModal from '../../../components/modals/editModal';

import Loader from '../../../components/loader/loader';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs, Image, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });


function SimpleProduct(props) {

  let { showAddModal, addModal, showEditModal, editModal, idRow, filter, refreshTableFunction } = props;


  const { userData, settingData, serverApi, api, refCategory, categoryData, refProductData, productData, devData } = useContext(DataContext);
  const userRole = userData.role;
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);

  // Add these state variables for branch pricing
  const [branchPrices, setBranchPrices] = useState([]);
  const [wareHouseData, setWareHouseData] = useState([]);

    // Fetch warehouse data
  useEffect(() => {
    const fetchWareHouses = async () => {
      try {
        const response = await api.get('/wareHouse/getAll', {
          params: { filter: { isActive: true } }
        });
        if (response.data.status) {
          setWareHouseData(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching warehouses:', error);
      }
    };
    fetchWareHouses();
  }, [api]);


// This is now the ONLY hook that should run when the modal opens
// This is now the ONLY hook that should run when the modal opens
useEffect(() => {
    // We need warehouses loaded and a modal to be open to proceed
    if (wareHouseData.length > 0 && (showAddModal || showEditModal)) {
        setSyncWithInitial(true); // Always reset sync when modal opens

        // EDIT MODE: A product is being edited
        if (idRow?.id) {
            
            // 1. Parse string values to numbers immediately and provide a fallback.
            // THIS IS THE MOST IMPORTANT FIX.
            const initialCost = parseFloat(idRow.cost) || 0;
            const initialPrice = parseFloat(idRow.price) || 0;
            const initialWholeSalePrice = parseFloat(idRow.wholeSalePrice) || 0;

            // 2. Calculate raiseBy using the clean numbers.
            const raiseBy = (initialCost && initialPrice) ? (((initialPrice - initialCost) / initialCost) * 100) : 0;

            // 3. Set the main form data using these determined numeric values.
            setSimpleProduct({
                createdBy: createdBy,
                type: idRow.type,
                name: idRow.name,
                barcode: idRow.barcode,
                categoryId: idRow.categoryId,
                sku: idRow.sku,
                isStock: idRow.isStock,
                isSale: idRow.isSale,
                isTva: idRow.isTva,
                cost: initialCost,
                price: initialPrice,
                raiseBy: raiseBy,
                wholeSalePrice: initialWholeSalePrice,
                color: idRow.color || "#b6e3f4",
                details: idRow.details || '',
                unit: idRow.unit || 'Pcs',
            });
            setCategory(categoryOptions.find(opt => opt.value === idRow.categoryId) || null);
            setRatedPrice(initialPrice * settingData.rate || 0);
            setProductUnits(idRow.units || []);
            if (devData.useMultiplePrice) {
                setProductPrices(idRow.prices && idRow.prices.length > 0 ? idRow.prices : [{ name: '', price: '' }]);
            }
            
            // 4. Fetch and merge branch prices, using the SAME numeric initial values for the fallback.
            // This avoids the race condition with the other useEffect.
            const fetchPrices = async () => {
                try {
                    const response = await api.get('/product/getBranchPrices', { params: { id: idRow.id } });
                    const fetchedPrices = response.data.status ? response.data.data : [];
                    const priceMap = new Map(fetchedPrices.map(p => [p.wareHouseId, p]));

                    const mergedPrices = wareHouseData.map(warehouse => {
                        const existingPrice = priceMap.get(warehouse.id);
                        // If no specific branch price exists, create one using the clean initial values.
                        return existingPrice || {
                            wareHouseId: warehouse.id,
                            wareHouse: { name: warehouse.name },
                            cost: initialCost,
                            price: initialPrice,
                            wholeSalePrice: initialWholeSalePrice,
                        };
                    });
                    setBranchPrices(mergedPrices);
                } catch (error) {
                    toast.error("Failed to load branch prices.");
                    console.error('Error fetching branch prices:', error);
                }
            };
            fetchPrices();
        }
        
        // ADD MODE: This is a new product
        else {
            resetForm(); // Use your existing reset function to clear the main form
            const initialPrices = wareHouseData.map(warehouse => ({
                wareHouseId: warehouse.id,
                wareHouse: { name: warehouse.name },
                cost: 0,
                price: 0,
                wholeSalePrice: 0
            }));
            setBranchPrices(initialPrices);
        }
    } else {
        // Clear prices when the modal is closed to avoid stale data
        setBranchPrices([]);
    }
}, [wareHouseData, idRow, showAddModal, showEditModal, api]); // Keep dependencies the same




    // Handle branch price changes
    const handleBranchPriceChange = (index, field, value) => {
        setSyncWithInitial(false); // <-- This is the key change to break the sync
        
        const updatedBranchPrices = [...branchPrices];
        const parsedValue = value === '' ? '' : parseFloat(value);
        updatedBranchPrices[index] = {
          ...updatedBranchPrices[index],
          [field]: parsedValue
        };
        setBranchPrices(updatedBranchPrices);
    };
  // Update branch prices
  const updateBranchPrices = async (productId) => {
    try {
      const response = await api.post('/product/updateBranchPrices', {
        id: productId,
        branchPrices: branchPrices
      });
      
      if (response.data.status) {
        toast.success('Branch prices updated successfully');
      } else {
        toast.error('Failed to update branch prices');
      }
    } catch (error) {
      console.error('Error updating branch prices:', error);
      toast.error('Error updating branch prices');
    }
  };


  // Category Options
  const categoryOptions = categoryData.map(item => ({
    value: item.id,
    label: item.name,
  }));

  categoryOptions.push({ value: null, label: 'All Categories' })

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [fileList, setFileList] = useState([
    {
      uid: '-1',
      name: 'image.png',
      status: 'done',
      url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
    },
    {
      uid: '-2',
      name: 'image.png',
      status: 'done',
      url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
    }
  ]);

  const [ratedPrice, setRatedPrice] = useState({});

  const [productUnits, setProductUnits] = useState([]);
  const [productPrices, setProductPrices] = useState([]);
  const [category, setCategory] = useState([]);
  const [simpleProduct, setSimpleProduct] = useState({});
  const [syncWithInitial, setSyncWithInitial] = useState(true); 
  const product = simpleProduct;

  // Add this new useEffect hook
const isInitialMount = useRef(true);

useEffect(() => {
    // Skip this effect on the very first render
    if (isInitialMount.current) {
        isInitialMount.current = false;
        return;
    }

    // If sync is active, update all branch prices to match the main product's prices
    if (syncWithInitial) {
        setBranchPrices(prev =>
            prev.map(branch => ({
                ...branch,
                cost: simpleProduct.cost || 0,
                price: simpleProduct.price || 0,
                wholeSalePrice: simpleProduct.wholeSalePrice || 0
            }))
        );
    }
}, [simpleProduct.cost, simpleProduct.price, simpleProduct.wholeSalePrice]); // Dependencies

  

  // idRow Change


  const table = 'product';
  const title = 'Simple Product';



  // Add VarientRow
  const handleAddRow = (array) => {
    if (array == 'units') {
      setProductUnits([...productUnits, { unit: '', value: '', productId: idRow?.id }]);
    } else
      if (array == 'price') {
        setProductPrices([...productPrices, { name: '', price: '', productId: idRow?.id }]);
      }
  };

  // Delete VarientRow
  const handleDeleteRow = (event, array) => {
    event.preventDefault()
    if (array == 'units') {
      if (productUnits.length > 0) {
        const updatedRows = productUnits.slice(0, -1);
        setProductUnits(updatedRows);
      } else {
        toast.error('you need at least one variant')
      }
    } else
      if (array == 'price') {
        if (productPrices.length > 1) {
          const updatedRows = productPrices.slice(0, -1);
          setProductPrices(updatedRows);
        } else {
          toast.error('you need at least one price')
        }

      }
  };

  // Change Unit Array
  const handleUnitChange = (index, field, value) => {
    const updatedUnits = [...productUnits];
    const parsedValue = field === 'value' ? parseFloat(value) : value;
    updatedUnits[index] = { ...updatedUnits[index], [field]: parsedValue };
    setProductUnits(updatedUnits);
  }

  // Change Price Array
  const handlePriceChange = (index, field, value) => {
    const updatedPrices = [...productPrices];
    const parsedValue = field === 'price' ? parseFloat(value) : value;
    updatedPrices[index] = { ...updatedPrices[index], [field]: parsedValue };
    setProductPrices(updatedPrices);
  }

  const resetForm = () => {
    setSyncWithInitial(true);
    setSimpleProduct({ createdBy: createdBy, type: 'simple', categoryId: filter.categoryId || null, unit: 'Pcs' })
    setCategory('')
    setProductUnits([])
    if (devData.useMultiplePrice) {
      setProductPrices(idRow?.prices || [{ name: '', price: '', productId: idRow?.id }])
    }
    setRatedPrice(0);
  }


  // Generic handler for input changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (value === 'true' || value === 'false') {
      value = JSON.parse(value)
    }

    // in case of rated price
    if (settingData.priceByRatedCurrency && name == 'price') {
      setRatedPrice(value);
      value = value / settingData.rate;
    }

    setSimpleProduct((prevProduct) => ({
      ...prevProduct,
      [name]: value,
    }));


    if (settingData.showRaiseBy && name == 'raiseBy') {
      const newPrice = simpleProduct.cost * (1 + value / 100);
      setSimpleProduct((prevProduct) => ({
        ...prevProduct,
        price: newPrice,
      }));

      if (settingData.priceByRatedCurrency) {
        setRatedPrice(Math.floor(newPrice * settingData.rate))
      }

    } else
      if (settingData.showRaiseBy && name == 'price' && simpleProduct.cost !== 0 && simpleProduct.cost !== '0') {
        const newRaiseBy = (((value - simpleProduct.cost) / simpleProduct.cost) * 100) || 0;
        setSimpleProduct((prevProduct) => ({
          ...prevProduct,
          raiseBy: newRaiseBy,
        }));
      }
      else
        if (settingData.showRaiseBy && name == 'cost') {
          const newPrice = value * (1 + simpleProduct.raiseBy / 100);
          setSimpleProduct((prevProduct) => ({
            ...prevProduct,
            price: newPrice,
          }));

          if (settingData.priceByRatedCurrency) {
            setRatedPrice(Math.floor(newPrice * settingData.rate));
          }


        }
  };

  const handleSelectChange = (selectedOption, name) => {
    setCategory(selectedOption)
    setSimpleProduct((prevProduct) => ({
      ...prevProduct,
      [name]: selectedOption.value,
    }));
  };



  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = ({ fileList: newFileList }) => {

    setFileList(newFileList);


    if (newFileList.length < fileList.length) {
    }
  }

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: 'none',
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );


  const formGeneral = {
    label: `General`,
    key: 1,
    children:

      <>

        {/* BarCode  */}
        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Label className='formLabel'><IoBarcodeOutline size={25} /> Barcode </Form.Label>
            <Form.Control type="text" name='barcode' placeholder="optional"
              value={simpleProduct?.barcode || ''}
              onChange={handleInputChange}
            />
          </Form.Group>

          {/* Name  */}
          <Form.Group as={Col}>
            <Form.Label className='formLabel'>Name<span style={{ color: 'red' }}> *</span></Form.Label>
            <Form.Control type="text" name='name'
              value={simpleProduct?.name || ''}
              onChange={handleInputChange}
              required
            />
          </Form.Group>

          {/* Sku  */}
          {(filter.categoryId && !idRow.categoryId) &&
            <Form.Group as={Col}>
              <Form.Label className='formLabel'>SKU</Form.Label>
              <Form.Control type="text" name="sku"
                value={simpleProduct?.sku || ''}
                onChange={handleInputChange} />
            </Form.Group>
          }

        </Row>

        <Row className="mb-3" style={{ marginTop: '4%' }}>

          {/* Category  */}
          {(!filter.categoryId || idRow.categoryId) &&
            <Form.Group as={Col}>
              <Form.Label className='formLabel'>Category<span style={{ color: 'red' }}> *</span></Form.Label>
              <Select
                style={{ width: '100px' }}
                options={categoryOptions.filter(option => option.value !== null)}
                isSearchable={true}
                placeholder="Select"
                value={category}
                onChange={e => handleSelectChange(e, 'categoryId')}
                required
              />
            </Form.Group>
          }


          {/* Sku  */}
          {(!filter.categoryId || idRow.categoryId) &&
            <Form.Group as={Col}>
              <Form.Label className='formLabel'>SKU</Form.Label>
              <Form.Control type="text" name="sku"
                value={simpleProduct?.sku || ''}
                onChange={handleInputChange} />
            </Form.Group>
          }


        </Row>

        <Row className="mb-3" style={{ marginTop: '2%' }}>

          {/* Sale */}
          <Form.Group as={Col}>
            <Form.Label className='formLabel'>Salable<span style={{ color: 'red' }}> *</span></Form.Label>
            <select className="form-control" name='isSale'
              value={simpleProduct?.isSale}
              onChange={handleInputChange}>
              <option value='true'>yes</option>
              <option value='false'>no</option>
            </select>
          </Form.Group>


          {/* Stockable */}
          <Form.Group as={Col}>
            <Form.Label className='formLabel'>Stockable<span style={{ color: 'red' }}> *</span></Form.Label>
            <select className="form-control" name='isStock'
              value={simpleProduct?.isStock}
              onChange={handleInputChange}>
              <option value='true'>yes</option>
              <option value='false'>no</option>
            </select>
          </Form.Group>
        </Row>

        <Row className="mb-3" style={{ marginTop: '4%' }}>

          {/* Cost */}
          <Form.Group as={Col}>
            <Form.Label className='formLabel'>Cost {settingData.currency}<span style={{ color: 'red' }}> *</span></Form.Label>
            <Form.Control type="number" step="any" name='cost'
              value={simpleProduct?.cost}
              onChange={handleInputChange}
              required />
          </Form.Group>


          {/* WholeSalePrice */}
          {settingData.showRaiseBy &&
            <Form.Group as={Col} >
              <Form.Label className='formLabel'>RaiseBy %</Form.Label>
              <Form.Control type="number" step="any" name="raiseBy"
                value={simpleProduct?.raiseBy}
                onChange={handleInputChange}
                required />
            </Form.Group>
          }



          {/* WholeSalePrice */}
          {userRole.wholeSale &&
            <Form.Group as={Col} >
              <Form.Label className='formLabel'>WholeSale Price</Form.Label>
              <Form.Control type="number" step="any" name="wholeSalePrice"
                value={simpleProduct?.wholeSalePrice}
                onChange={handleInputChange}
                required />
            </Form.Group>
          }


          {/* Price */}
          {!settingData.priceByRatedCurrency &&
            <Form.Group as={Col} >
              <Form.Label className='formLabel'>Price {settingData.currency}<span style={{ color: 'red' }}> *</span></Form.Label>
              <Form.Control type="number" step="any" name="price"
                value={simpleProduct?.price} 
                onChange={handleInputChange}
                required />
            </Form.Group>
          }

          {/* Price */}
          {settingData.priceByRatedCurrency &&
            <Form.Group as={Col} >
              <Form.Label className='formLabel'>Price {settingData.ratedCurrency}<span style={{ color: 'red' }}> *</span></Form.Label>
              <Form.Control type="number" step="any" name="price"
                value={ratedPrice}
                onChange={handleInputChange}
                required />
            </Form.Group>
          }



        </Row>

        <Row className="mb-3" style={{ marginTop: '2%' }}>

          {/* Details */}
          <Form.Group as={Col} sm={6}>
            <Form.Label className='formLabel'>Description</Form.Label>
            <Form.Control as="textarea" name="details"
              value={simpleProduct?.details || ''}
              onChange={handleInputChange} />
          </Form.Group>

          {/* isTva */}
          <Form.Group as={Col}>
            <Form.Label className='formLabel'>TVA<span style={{ color: 'red' }}> *</span></Form.Label>
            <select className="form-control" name='isTva'
              value={simpleProduct?.isTva}
              onChange={handleInputChange}>
              <option value='true'>yes</option>
              <option value='false'>no</option>
            </select>
          </Form.Group>


          <Form.Group as={Col}>
            <Form.Label className='formLabel' htmlFor="exampleColorInput">Box Color</Form.Label>
            <Form.Control
              type="color"
              name="color"
              title="Choose your color"
              value={simpleProduct.color}
              onChange={handleInputChange}
            />
          </Form.Group>
        </Row>
      </>


  };

  const secondaryUnit = {
    label: `Units`,
    key: 2,
    children: (
      <>
        <Row className="mb-3">

          {/* Product Unit  */}
          <Form.Group as={Col}>
            <Form.Label className='formLabel'>Product Unit</Form.Label>
            <Form.Control type="text" name="unit"
              value={simpleProduct?.unit}
              onChange={handleInputChange} />
          </Form.Group>

        </Row>

        {productUnits.map((row, index) => (
          <div key={index}>
            {/* Render the labels only for the first row */}
            {index === 0 && (
              <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label className='formLabel'>Unit</Form.Label>
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label className='formLabel'>Value</Form.Label>
                </Form.Group>
              </Row>
            )}

            <Row className="mb-3" style={{ marginTop: '-20px' }}>

              <Form.Group as={Col}>
                <Form.Control type="text" name="unit"
                  onChange={(e) => handleUnitChange(index, 'unit', e.target.value)}
                  value={row.unit} />
              </Form.Group>

              <Form.Group as={Col}>
                <Form.Control type="number" step="any" name="value"
                  onChange={(e) => handleUnitChange(index, 'value', e.target.value)}
                  value={row.value} />
              </Form.Group>



            </Row>

            <Row key={index + 100} className="mb-3">

            </Row>
          </div>
        ))}

        <Form.Group
          as={Col}
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={() => handleAddRow('units')} />
          <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e, 'units')} />
        </Form.Group>
      </>
    )
  }

  const formImages = {
    label: `Images`,
    key: 3,
    children:

      <>

        {/* Main Image  */}
        <Row className="mb-3">



          <Form.Group>
            <Form.Label className='formLabel'><IoBarcodeOutline size={25} /> Image </Form.Label>

            <Upload
              action=""
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              onChange={handleChange}
            >
              {fileList.length >= 8 ? null : uploadButton}
            </Upload>
            {previewImage && (
              <Image
                wrapperStyle={{
                  display: 'none',
                }}
                preview={{
                  visible: previewOpen,
                  onVisibleChange: (visible) => setPreviewOpen(visible),
                  afterOpenChange: (visible) => !visible && setPreviewImage(''),
                }}
                src={previewImage}
              />
            )}


          </Form.Group>


        </Row>
      </>


  }

  const multiplePrice = {
    label: `Price`,
    key: 3,
    children: (
      <>

        {productPrices.map((row, index) => (
          <div key={index}>
            {/* Render the labels only for the first row */}
            {index === 0 && (
              <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label className='formLabel'>Name</Form.Label>
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label className='formLabel'>Price</Form.Label>
                </Form.Group>
              </Row>
            )}

            <Row className="mb-3" style={{ marginTop: '-20px' }}>

              <Form.Group as={Col}>
                <Form.Control type="text" name="name"
                  onChange={(e) => handlePriceChange(index, 'name', e.target.value)}
                  value={row.name}
                  required
                />
              </Form.Group>

              <Form.Group as={Col}>
                <Form.Control type="number" step="any" name="price"
                  onChange={(e) => handlePriceChange(index, 'price', e.target.value)}
                  value={row.price}
                  required
                />
              </Form.Group>



            </Row>

            <Row key={index + 100} className="mb-3">

            </Row>
          </div>
        ))}

        <Form.Group
          as={Col}
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={() => handleAddRow('price')} />
          <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e, 'price')} />
        </Form.Group>
      </>
    )
  }

const branchPricing = {
    label: `Branch Pricing`,
    key: 4,
    children: (
      <>
        {/* Column Headers */}
        <Row className="mb-3">
           <Form.Group as={Col}><Form.Label style={{fontWeight: 'bold'}}>Warehouse</Form.Label></Form.Group>
           <Form.Group as={Col}><Form.Label style={{fontWeight: 'bold'}}>Cost</Form.Label></Form.Group>
           <Form.Group as={Col}><Form.Label style={{fontWeight: 'bold'}}>Price</Form.Label></Form.Group>
           {userRole.wholeSale && <Form.Group as={Col}><Form.Label style={{fontWeight: 'bold'}}>Wholesale Price</Form.Label></Form.Group>}
        </Row>

        {/* Price Inputs */}
        {branchPrices.map((branch, index) => (
          <Row key={branch.wareHouseId} className="mb-2 align-items-center">
            <Form.Group as={Col}>
              <Form.Label>{branch.wareHouse?.name}</Form.Label>
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Control 
                type="number" 
                step="any"
                placeholder="Cost"
                value={branch.cost === null ? '' : branch.cost}
                onChange={(e) => handleBranchPriceChange(index, 'cost', e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Control 
                type="number" 
                step="any"
                placeholder="Price"
                value={branch.price === null ? '' : branch.price}
                onChange={(e) => handleBranchPriceChange(index, 'price', e.target.value)}
              />
            </Form.Group>
            {userRole.wholeSale && 
              <Form.Group as={Col}>
                <Form.Control 
                  type="number" 
                  step="any"
                  placeholder="Wholesale Price"
                  value={branch.wholeSalePrice === null ? '' : branch.wholeSalePrice}
                  onChange={(e) => handleBranchPriceChange(index, 'wholeSalePrice', e.target.value)}
                />
              </Form.Group>
            }
          </Row>
        ))}
      </>
    )
  };
  
  

  const items = [formGeneral];

  if (settingData.useSecondaryUnit) {
    items.push(secondaryUnit)
  }

  if (settingData.useImage) {
    items.push(formImages)
  }

  if (devData.useMultiplePrice) {
    items.push(multiplePrice)
  }

  if (settingData.useBranchPrice) {
    items.push(branchPricing)
  }

  const formView = (
    <div style={{ userSelect: 'none' }}>

      <Tabs
        defaultActiveKey="1"
        centered
        items={items}
      />


    </div >);


  const modalFooter = (
    <div>

    </div>
  );



  return (
    <>



      <AddModal
        showModal={showAddModal}
        toggleModal={() => addModal('simple')}
        formView={formView}
        idRow={idRow}
        table={table}
        title={title}
        refreshTable={refreshTableFunction}
        size={'lg'}
        resetForm={resetForm}
        footer={modalFooter}
        api={api}
        data={{ product, productUnits, productPrices, fileList, branchPrices }}
      />

      <EditModal
        showModal={showEditModal}
        toggleModal={() => editModal('simple', null)}
        formView={formView}
        idRow={idRow}
        table={table}
        title={title}
        refreshTable={refreshTableFunction}
        size={'lg'}
        footer={modalFooter}
        api={api}
        data={{ id: idRow?.id, product, productUnits, productPrices, branchPrices }}
      />

    </>
  )
}

export default SimpleProduct;
